import { useEffect, useRef, useState } from "react";
import { LiaSearchPlusSolid, LiaSearchSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import {
  materialInward,
  rawMaterials,
  supplierDieAPI,
  Unit,
} from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Model from "../../common/Model";
import FormFields from "../../common/FormFields";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import EntityAddModal from "../../common/EntityAddModal";
import { formatDate } from "../../utlis/formateDate";
import { RegistryHeader, Button as SharedButton } from "../../common/Shared";

import MaterialInwardForm from "./MaterialInwardForm";

const MaterialInward = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const today = new Date().toISOString()?.split("T")[0];
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    inward_No: 0,
    inward_Date: today,
    skU_No: "",
    supplier_Id: "",
    material_Id: "",
    weight_Sleep1: "",
    weight_Sleep2: "",
    quantity: "",
    unit_Id: "",
    rate: "",
    origin: "",
    invoice_No: "",
    grade: "",
    batch_No: "",
    vehicle_No: "",
    notes: "",
    image_Upload: null,
    created_By: userId,
  });

  const [loading, setLoading] = useState(false);
  const [isMaterialInwardData, setIsMaterialInwardData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isSupplierData, setIsSupplierData] = useState([]);
  const [isRawMaterialData, setIsRawMaterialData] = useState([]);
  const [isUnitData, setIsUnitData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(50);
  const [modalType, setModalType] = useState(null);
  const tableScrollRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const isFetchingRef = useRef(false);

  const fetchInwardData = async () => {
    if (isFetchingRef.current) return;
    setLoading(true);
    try {
      const res = await materialInward.getAllmaterialInward(
        currentPage,
        pageSize,
      );
      if (currentPage === 1) {
        setIsMaterialInwardData(res.items || []);
      } else {
        setIsMaterialInwardData((prev) => [...prev, ...(res.items || [])]);
      }

      if (!res.items || res.items.length < pageSize) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }

      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching die master data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || !hasMore || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 120) {
        isFetchingRef.current = true;
        setCurrentPage((p) => p + 1);
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [rawMaterialRes, supplierRes, unitRes] = await Promise.all([
          rawMaterials.getAll(),
          supplierDieAPI.getAll(),
          Unit.getAll(),
        ]);

        setIsRawMaterialData(
          Array.isArray(rawMaterialRes)
            ? rawMaterialRes
            : rawMaterialRes?.data || [],
        );

        const supplierArray = Array.isArray(supplierRes?.data)
          ? supplierRes.data
          : [];
        setIsSupplierData(supplierArray);

        setIsUnitData(Array.isArray(unitRes) ? unitRes : unitRes?.data || []);
      } catch (error) {
        notify("Error fetching dropdown data", "error");
      }
    };

    fetchDropdownData();
  }, []);

  useEffect(() => {
    fetchInwardData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isMaterialInwardData);
    } else {
      const filtered = isMaterialInwardData.filter((d) =>
        d.material_Name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        d.skU_No?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        d.supplier_Name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        d.invoice_No?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isMaterialInwardData]);

  const handleInputChange = (e) => {
    const { name, type, files, value } = e.target;

    if (type === "file") {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleAdd = () => {
    setIsEditing(false);
    setFormData({
      inward_No: 0,
      inward_Date: today,
      skU_No: "",
      supplier_Id: "",
      material_Id: "",
      weight_Sleep1: "",
      weight_Sleep2: "",
      quantity: "",
      unit_Id: "",
      rate: "",
      origin: "",
      invoice_No: "",
      grade: "",
      batch_No: "",
      vehicle_No: "",
      notes: "",
      image_Upload: null,
      created_By: userId,
    });
    setIsModelOpen(true);
  };

  const handleEdit = async (id) => {
    try {
      const data = await materialInward.getById(id);

      if (data) {
        setFormData({
          inward_No: data.inward_No,
          inward_Date: data.inward_Date?.split("T")[0],
          skU_No: data.skU_No,
          supplier_Id: data.supplier_Id,
          material_Id: data.material_Id,
          weight_Sleep1: data.weight_Sleep1,
          weight_Sleep2: data.weight_Sleep2,
          quantity: data.quantity,
          unit_Id: data.unit_Id,
          rate: data.rate,
          origin: data.origin,
          invoice_No: data.invoice_No,
          grade: data.grade,
          batch_No: data.batch_No,
          vehicle_No: data.vehicle_No,
          notes: data.notes,
          image_Upload: data.image_Upload,
          created_By: userId,
        });
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (error) {
      notify("Failed to fetch location details", "error");
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await materialInward.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchInwardData();
    } catch (error) {
      notify("Failed to delete record", "error");
    }
    setIsDeleteModalOpen(false);
    setSelectedId(null);
  };

  const handleSubmit = async ({ resetOnly = false }) => {
    setIsSaving(true);
    try {
      const payload = {
        ...formData,
        material_Id: parseInt(formData.material_Id),
        supplier_Id: parseInt(formData.supplier_Id),
        unit_Id: parseInt(formData.unit_Id),
      };
      await materialInward.saveOrUpdate(payload);
      notify(
        isEditing ? "Updated successfully" : "Added successfully",
        "success",
      );
      fetchInwardData();

      if (resetOnly) {
        // Reset form for next entry
        setFormData({
          inward_No: 0,
          inward_Date: today,
          skU_No: "",
          supplier_Id: "",
          material_Id: "",
          weight_Sleep1: "",
          weight_Sleep2: "",
          quantity: "",
          unit_Id: "",
          rate: "",
          origin: "",
          invoice_No: "",
          grade: "",
          batch_No: "",
          vehicle_No: "",
          notes: "",
          image_Upload: null,
          created_By: userId,
        });
      } else {
        setIsModelOpen(false);
        setFormData({
          inward_No: 0,
          inward_Date: today,
          skU_No: "",
          supplier_Id: "",
          material_Id: "",
          weight_Sleep1: "",
          weight_Sleep2: "",
          quantity: "",
          unit_Id: "",
          rate: "",
          origin: "",
          invoice_No: "",
          grade: "",
          batch_No: "",
          vehicle_No: "",
          notes: "",
          image_Upload: null,
          created_By: userId,
        });
        setIsEditing(false);
      }
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleEntityAddSuccess = async (type, newOption) => {
    const config = {
      supplier: {
        setter: setIsSupplierData,
        fetcher: supplierDieAPI.getAll,
        setField: "supplier_Id",
      },
      rawMaterial: {
        setter: setIsRawMaterialData,
        fetcher: rawMaterials.getAll,
        setField: "material_Id",
      },
      unit: {
        setter: setIsUnitData,
        fetcher: Unit.getAll,
        setField: "unit_Id",
      },
    }[type];

    if (!config) return;

    try {
      const response = await config.fetcher();
      const items = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      config.setter(items);

      const newValue = newOption?.value || newOption?.id || newOption?.supplier_Id || newOption?.material_Id || newOption?.unit_Id || "";

      setFormData((prev) => ({
        ...prev,
        [config.setField]: newValue,
      }));
      setModalType(null);
    } catch (err) {
      notify("Failed to refresh dropdown", "error");
    }
  };

  if (isModelOpen) {
    return (
      <MaterialInwardForm
        formData={formData}
        isEditing={isEditing}
        isSaving={isSaving}
        onSave={handleSubmit}
        onCancel={() => {
          setIsModelOpen(false);
          setFormData(null);
          setIsEditing(false);
        }}
        isSupplierData={isSupplierData}
        isRawMaterialData={isRawMaterialData}
        isUnitData={isUnitData}
        handleInputChange={handleInputChange}
        onEntityAddSuccess={handleEntityAddSuccess}
      />
    );
  }

  return (
    <div className="flex flex-col h-full bg-white font-plus">
      <RegistryHeader title="Material Inward">
        <div className="relative w-full sm:w-80 group">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none group-focus-within:text-[#3F80F7]">
            <LiaSearchSolid size={18} className="text-gray-400 transition-colors" />
          </div>
          <input
            type="text"
            placeholder="Search..."
            className="block w-full pl-12 pr-10 py-2.5 bg-gray-50 border border-gray-200 text-gray-900 text-[11px] font-black uppercase tracking-[2px] focus:border-[#3F80F7] focus:bg-white focus:outline-none transition-all placeholder:text-gray-300"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-red-500 transition-colors"
            >
              <MdClose size={18} />
            </button>
          )}
        </div>

        <SharedButton
          onClick={handleAdd}
          icon={HiOutlinePlus}
          className="whitespace-nowrap"
        >
          Add Material Inward
        </SharedButton>
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col">
        <div
          ref={tableScrollRef}
          className="relative overflow-auto border border-gray-200 bg-white flex-1 "
        >
          <div className="min-w-max">
            {loading && currentPage === 1 && <Loader centered />}
            <Table
              columns={[
                {
                  key: "inward_Date",
                  label: "DATE",
                  render: (value) => formatDate(value),
                },
                { key: "skU_No", label: "SKU NO" },
                { key: "supplier_Name", label: "SUPPLIER" },
                { key: "material_Name", label: "MATERIAL" },
                { key: "quantity", label: "QTY" },
                { key: "unit_Name", label: "UNIT" },
                { key: "rate", label: "RATE" },
                { key: "origin", label: "ORIGIN" },
                { key: "invoice_No", label: "INVOICE NO" },
                { key: "grade", label: "GRADE" },
                { key: "batch_No", label: "BATCH" },
                { key: "vehicle_No", label: "VEHICLE" },
                { key: "notes", label: "REMARK" },
              ]}
              data={filteredData}
              onEdit={(row) => handleEdit(row.inward_No)}
              onDelete={(row) => handleDelete(row.inward_No)}
              tableClassName="text-[12px] font-bold"
            />
          </div>
        </div>
      </div>

      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </div>
  );
};


export default MaterialInward;
